module.exports = __webpack_public_path__ + "static/img/coin.f9c8ad46.png";